import CustomChip from '@app/components/atoms/CustomChip/CustomChip'
import Section from '@app/components/atoms/Section/Section'
import CardWidget from '@app/components/CardWidget'
import ImageSlider from '@app/components/ImageSlider'
import { formatNumber, formatPrice } from '@app/libs/format'
import { toDateTime, toRemainingTime } from '@app/libs/format'
import { useRemember } from '@app/libs/useRemember'

import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Collapse from '@mui/material/Collapse'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

const CustomIconButton = styled(IconButton)(({ theme, open }) =>
  open
    ? {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shortest,
        }),
      }
    : {
        transform: 'rotate(180deg)',
      }
)

const CampaignDetail = ({ campaign, voucherByType }) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  const [expandedDescription, setExpandedDescription] = useRemember(`campaign-description:${campaign.id}`, true)
  const handleExpandClickDescription = () => {
    setExpandedDescription(!expandedDescription)
    setOpen(!open)
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Section>
          <Grid container spacing={2}>
            <Grid item md={4} sm={12} xs={12}>
              <ImageSlider images={campaign.images} />
            </Grid>
            <Grid item md={8} sm={12} xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={11}>
                  <Typography variant="h4">{campaign.name}</Typography>
                </Grid>

                <Grid item xs={4}>
                  <Typography color="textSecondary" variant="body1">
                    {t('CAMPAIGN.PARTNER_NAME')}
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  {campaign.partner.name ? (
                    <Typography variant="body1">{campaign.partner.name}</Typography>
                  ) : (
                    <Typography color="textSecondary" variant="body1">
                      {t('CAMPAIGN.NOT_SET')}
                    </Typography>
                  )}
                </Grid>
                <Grid item xs={4}>
                  <Typography color="textSecondary" variant="body1">
                    {t('CAMPAIGN.VISIBLE_FROM')}
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  {campaign.visible_from ? (
                    <Typography variant="body1">{toDateTime(campaign.visible_from)}</Typography>
                  ) : (
                    <Typography color="textSecondary" variant="body1">
                      {t('CAMPAIGN.NOT_SET')}
                    </Typography>
                  )}
                </Grid>
                <Grid item xs={4}>
                  <Typography color="textSecondary" variant="body1">
                    {t('CAMPAIGN.VISIBLE_TO')}
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  {campaign.visible_to ? (
                    <Typography variant="body1">{toDateTime(campaign.visible_to)}</Typography>
                  ) : (
                    <Typography color="textSecondary" variant="body1">
                      {t('CAMPAIGN.NOT_SET')}
                    </Typography>
                  )}
                </Grid>
                <Grid item xs={4}>
                  <Typography color="textSecondary" variant="body1">
                    {t('CAMPAIGN.START_TIME')}
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  {campaign.start_at ? (
                    <Typography variant="body1">{toDateTime(campaign.start_at)}</Typography>
                  ) : (
                    <Typography color="textSecondary" variant="body1">
                      {t('CAMPAIGN.NOT_SET')}
                    </Typography>
                  )}
                </Grid>

                <Grid item xs={4}>
                  <Typography color="textSecondary" variant="body1">
                    {t('CAMPAIGN.END_TIME')}
                  </Typography>
                </Grid>

                <Grid item xs={8}>
                  {campaign.end_at ? (
                    <Typography variant="body1">{toDateTime(campaign.end_at)}</Typography>
                  ) : (
                    <Typography color="textSecondary" variant="body1">
                      {t('CAMPAIGN.NOT_SET')}
                    </Typography>
                  )}
                </Grid>
                <Grid item xs={4}>
                  <Typography color="textSecondary" variant="body1">
                    {t('CAMPAIGN.REMAIN_TIME')}
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  {campaign.end_at ? (
                    toRemainingTime(campaign.start_at, campaign.end_at)
                  ) : (
                    <Typography color="textSecondary" variant="body1">
                      {t('CAMPAIGN.NOT_SET')}
                    </Typography>
                  )}
                </Grid>
                <Grid item xs={4}>
                  <Typography color="textSecondary" variant="body1">
                    {t('CAMPAIGN.LIMIT_CODE_PER_USER')}
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  {campaign.codes_per_day ? (
                    <Typography variant="body1">{formatNumber(campaign.codes_per_day)}</Typography>
                  ) : (
                    <Typography color="textSecondary" variant="body1">
                      {t('CAMPAIGN.NOT_SET')}
                    </Typography>
                  )}
                </Grid>
                <Grid item xs={4}>
                  <Typography color="textSecondary" variant="body1">
                    {t('CAMPAIGN.TIME_BETWEEN_REDEEM_CODE')}
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  {campaign.time_between_redeem ? (
                    <Typography variant="body1">{campaign.time_between_redeem}</Typography>
                  ) : (
                    <Typography color="textSecondary" variant="body1">
                      {t('CAMPAIGN.NOT_SET')}
                    </Typography>
                  )}
                </Grid>

                <Grid item xs={4}>
                  <Typography color="textSecondary" variant="body1">
                    {t('CAMPAIGN.LINE_OF_CREDIT')}
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography variant="body1">{formatPrice(campaign.line_of_credit)}</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography color="textSecondary" variant="body1">
                    {t('CAMPAIGN.STATUS')}
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <CustomChip color={campaign.status} label={t(`CAMPAIGN.${campaign.status.toUpperCase()}`)} />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Section>
      </Grid>

      {voucherByType.map((item, index) => (
        <Grid item key={index} xs={12}>
          <Section>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="h5">{t(`VOUCHER.${item.type.toUpperCase()}_VOUCHER`)} </Typography>
              </Grid>
              <Grid item lg={4} md={6} sm={12} xs={12}>
                <CardWidget color="info" primary={item.amount_codes} title={t('CAMPAIGN.TOTAL_CODES')}></CardWidget>
              </Grid>

              <Grid item lg={4} md={6} sm={12} xs={12}>
                <CardWidget color="info" primary={item.count_voucher} title={t('CAMPAIGN.TOTAL_VOUCHERS')}></CardWidget>
              </Grid>

              <Grid item lg={4} md={6} sm={12} xs={12}>
                <CardWidget
                  color="info"
                  line_of_credit={campaign.line_of_credit}
                  primary={item.total_cost}
                  title={t('CAMPAIGN.TOTAL_COST')}
                  type={item.type}
                ></CardWidget>
              </Grid>

              <Grid item lg={4} md={6} sm={12} xs={12}>
                <CardWidget
                  amount_codes={item.amount_codes}
                  color="success"
                  percent={true}
                  primary={item.redeemed_codes}
                  title={t('CAMPAIGN.REDEEMED_CODES')}
                ></CardWidget>
              </Grid>

              <Grid item lg={4} md={6} sm={12} xs={12}>
                <CardWidget
                  amount_codes={item.amount_codes}
                  color="danger"
                  percent={true}
                  primary={item.used_codes}
                  title={t('CAMPAIGN.USED_CODES')}
                ></CardWidget>
              </Grid>
              {'premium' === item.type && (
                <Grid item lg={4} md={6} sm={12} xs={12}>
                  <CardWidget
                    amount_codes={item.amount_codes}
                    color="danger"
                    percent={true}
                    primary={item.available_codes}
                    title={t('CAMPAIGN.AVAILABLE_CODES')}
                  ></CardWidget>
                </Grid>
              )}
            </Grid>
          </Section>
        </Grid>
      ))}
      <Grid item xs={12}>
        <Section>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h5">
                {t('CAMPAIGN.DESCRIPTION')}{' '}
                <CustomIconButton
                  aria-expanded={expandedDescription}
                  aria-label="show more"
                  open={open}
                  onClick={handleExpandClickDescription}
                >
                  <ExpandMoreIcon />
                </CustomIconButton>
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Collapse unmountOnExit in={expandedDescription} timeout="auto">
                {campaign.description ? (
                  <Typography
                    dangerouslySetInnerHTML={{ __html: campaign.description }}
                    style={{ wordBreak: 'break-all' }}
                    variant="body1"
                  ></Typography>
                ) : (
                  <Typography color="textSecondary" variant="body1">
                    {t('CAMPAIGN.NOT_SET')}
                  </Typography>
                )}
              </Collapse>
            </Grid>
          </Grid>
        </Section>
      </Grid>
    </Grid>
  )
}

export default CampaignDetail
